module.exports = __webpack_public_path__ + "img/tuberia para ercas.3eb2840c.jpg";